import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

function Footer() {
  const history = useHistory();

  const handleSelectChange = (event) => {
    const siteUrl = event.target.value;
    if (siteUrl) {
      window.open(siteUrl, "_blank");
    }
  };

  useEffect(
    () => {
      window.addEventListener("scroll", getCurrentScroll);

      return () => window.removeEventListener("scroll", getCurrentScroll);
    },
    // eslint-disable-next-line
    []
  );

  // scroll에 따라 top이동 버튼
  const [scrollRevealCss, setScrollRevealCss] = useState(
    "backtop js-scroll-trigger"
  );
  const getCurrentScroll = () => {
    if (window.scrollY > 300) {
      setScrollRevealCss("backtop js-scroll-trigger reveal");
    } else {
      setScrollRevealCss("backtop js-scroll-trigger");
    }
  };

  const fnMoveTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer section gray-bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mr-auto col-sm-6">
            <div className="widget mb-5 mb-lg-0">
              <div className="logo mb-4">
                <img src="../images/logo.png" alt="" className="img-fluid" />
              </div>

              <ul className="list-inline">
                <li className="p-1 ml-3 mr-3">
                  <select
                    onChange={handleSelectChange}
                    className="form-select col-12"
                    style={{ paddingLeft: "10px" }}
                  >
                    <option value="">관련사이트</option>
                    <option value="http://www.hyundai-motor.com">
                      현대자동차
                    </option>
                    <option value="http://www.gm-korea.co.kr">한국GM</option>
                    <option value="http://www.kia.co.kr">기아자동차</option>
                    <option value="http://www.renaultsamsungm.com">
                      르노삼성자동차
                    </option>
                    <option value="http://www.smotor.com">쌍용자동차</option>
                  </select>
                </li>
                <li className="p-1 ml-3 mr-3">
                  <select
                    onChange={handleSelectChange}
                    className="form-select col-12"
                    style={{ paddingLeft: "10px" }}
                  >
                    <option value="">시군청</option>
                    <option value="https://state.gwd.go.kr">
                      강원특별자치도청
                    </option>
                    <option value="https://www.chuncheon.go.kr">
                      춘천시청
                    </option>
                    <option value="http://www.wonju.go.kr">원주시청</option>
                    <option value="http://www.gangneung.go.kr">강릉시청</option>
                    <option value="https://www.dh.go.kr">동해시청</option>
                    <option value="http://www.taebaek.go.kr">태백시청</option>
                    <option value="http://www.sokcho.go.kr">속초시청</option>
                    <option value="http://www.samcheok.go.kr">삼척시청</option>
                    <option value="https://www.hongcheon.go.kr">
                      홍천군청
                    </option>
                    <option value="http://www.hsg.go.kr">횡성군청</option>
                    <option value="http://www.yw.go.kr">영월군청</option>
                    <option value="http://www.happy700.or.kr">평창군청</option>
                    <option value="http://www.jeongseon.go.kr">정선군청</option>
                    <option value="http://www.cwg.go.kr">철원군청</option>
                    <option value="http://www.ihc.go.kr">화천군청</option>
                    <option value="http://www.yanggu.go.kr">양구군청</option>
                    <option value="http://www.inje.go.kr">인제군청</option>
                    <option value="http://www.gwgs.go.kr">고성군청</option>
                    <option value="https://www.yangyang.go.kr">양양군청</option>
                  </select>
                </li>
                <li className="p-1 ml-3 mr-3">
                  <select
                    onChange={handleSelectChange}
                    className="form-select col-12"
                    style={{ paddingLeft: "10px" }}
                  >
                    <option value="">시도조합</option>
                    <option value="http://www.kaima.or.kr">연합회</option>
                    <option value="http://www.ttoo.co.kr">서울조합</option>
                    <option value="http://www.psttoo.co.kr">부산조합</option>
                    <option value="http://www.dgjohab.co.kr">대구조합</option>
                    <option value="http://www.inja.co.kr">인천조합</option>
                    <option value="http://www.gjttoo.co.kr">광주조합</option>
                    <option value="http://www.djttoo.co.kr">대전조합</option>
                    <option value="http://www.ggttoo.co.kr">경기조합</option>
                    <option value="http://www.cbttoo.co.kr">충북조합</option>
                    <option value="http://www.cnttoo.co.kr">충남조합</option>
                    <option value="http://www.jbttoo.co.kr">전북조합</option>
                    <option value="http://www.jnttoo.co.kr">전남조합</option>
                    <option value="http://www.mgb.or.kr">경북조합</option>
                    <option value="http://www.gngjj.co.kr">경남조합</option>
                    <option value="http://www.jjttoo.co.kr">제주조합</option>
                    <option value="http://www.usttoo.co.kr">울산조합</option>
                    <option value="http://www.knauto.com">경기북부</option>
                  </select>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-5 col-md-6 col-sm-6">
            <div className="widget mb-5 mb-lg-0">
              <h4 className="text-capitalize mb-3">찾아오시는 길</h4>
              <div className="divider mb-4"></div>

              <ul className="list-unstyled footer-menu lh-35">
                <li
                  onClick={() => history.push("/Directions")}
                  style={{ cursor: "pointer" }}
                >
                  <img src="../images/mini-map.png" alt="" />
                </li>
                <li>(24217) 강원특별자치도 춘천시 동면 만천로 57</li>
              </ul>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="widget widget-contact mb-5 mb-lg-0">
              <h4 className="text-capitalize mb-3">연락처</h4>
              <div className="divider mb-4"></div>

              <div className="footer-contact-block mb-4">
                <div className="icon d-flex align-items-center">
                  <i className="icofont-telephone mr-2"></i>
                  <span className="h6 mb-0">전화</span>
                </div>
                <h4 className="mt-2">
                  <a href="tel:033-254-4825">033)254-4825, 5076</a>
                </h4>
              </div>

              <div className="footer-contact-block">
                <div className="icon d-flex align-items-center">
                  <i className="icofont-fax mr-3"></i>
                  <span className="h6 mb-0">팩스</span>
                </div>
                <h4 className="mt-2">033)257-0741, 0743</h4>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-btm py-4 mt-5">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-12">
              <div className="copyright">
                &copy; Copyright (C) 2021{" "}
                <span className="text-color">
                  강원특별자치도자동차검사정비사업조합
                </span>
                , All Rights reserved
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4">
              <span className={scrollRevealCss} onClick={fnMoveTop}>
                <i className="icofont-long-arrow-up"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
